// The A/B badge, handed down rather than laid over — `clientSwitchContext.ts`'s
// shape, for the same reason: each client renders it inside its own tree,
// beside the cutover button.
//
// `src/clientSwitch.tsx` provides it. Not dev-only: the badge gates itself on
// the account's role, so a production build provides one too. `null` is a
// client mounted without the switch (a story, a test).

import { createContext, useContext, type ReactNode } from "react";

export const ExperimentsBadgeContext = createContext<ReactNode>(null);

/** The A/B badge to render, or `null` where there is none. */
export function useExperimentsBadge(): ReactNode {
  return useContext(ExperimentsBadgeContext);
}
